import { reduxRequest } from "../../../../common/utils/reduxRequest";
import { makeFilterString } from "../../utils/Helper";
import {
  EventTypesLoading,
  GetAvailableEventServicesSuccess,
  GetEventTypeDetailsSuccess,
  GetEventTypesSuccess,
  GetEventTypeServicesSuccess,
  GetScrollEventTypesSuccess,
} from "./Action";

export const getEventTypesRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: EventTypesLoading,
    loadingType: "list",
    successFunction: GetEventTypesSuccess,
    url: `/admin/events/event_types${makeFilterString(variables?.params)}`,
    method: "get",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getScrollEventTypesRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: EventTypesLoading,
    loadingType: "filter-event-types-list",
    successFunction: GetScrollEventTypesSuccess,
    url: `/admin/events/event_types${makeFilterString(variables?.params)}`,
    method: "get",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const createEventTypeRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: EventTypesLoading,
    loadingType: "add",
    action: variables?.action,
    url: `/admin/events/event_types`,
    method: "post",
    data: variables?.body,
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getEventTypeDetailsRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: EventTypesLoading,
    loadingType: "details",
    successFunction: GetEventTypeDetailsSuccess,
    action: variables?.action,
    url: `/admin/events/event_types/${variables?.id}`,
    method: "get",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const updateEventTypeRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: EventTypesLoading,
    loadingType: "update",
    url: `/admin/events/event_types/${variables?.id}`,
    action: variables?.action,
    data: variables?.body,
    method: "put",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const activateEventTypeRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: EventTypesLoading,
    loadingType: "activate",
    action: variables?.action,
    url: `/admin/events/event_types/${variables?.id}/activate`,
    method: "put",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const deactivateEventTypeRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: EventTypesLoading,
    loadingType: "deactivate",
    action: variables?.action,
    url: `/admin/events/event_types/${variables?.id}/deactivate`,
    method: "put",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const deleteEventTypeRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: EventTypesLoading,
    loadingType: "delete",
    action: variables?.action,
    url: `/admin/events/event_types/${variables?.id}`,
    method: "delete",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getEventTypeServicesRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: EventTypesLoading,
    loadingType: "services",
    successFunction: GetEventTypeServicesSuccess,
    action: variables?.action,
    url: `/admin/events/event_types/${variables?.id}/services${makeFilterString(
      variables?.params,
    )}`,
    method: "get",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getAvailableEventServicesRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: EventTypesLoading,
    loadingType: "available-services",
    successFunction: GetAvailableEventServicesSuccess,
    action: variables?.action,
    url: `/admin/events/services${makeFilterString(variables?.params)}`,
    method: "get",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const addEventTypeServiceRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: EventTypesLoading,
    loadingType: "add-service",
    action: variables?.action,
    url: `/admin/events/event_types/${variables?.id}/services`,
    method: "post",
    data: variables?.body,
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const removeEventTypeServiceRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: EventTypesLoading,
    loadingType: "remove-service",
    action: variables?.action,
    url: `/admin/events/event_types/${variables?.id}/services/${variables?.product_id}`,
    method: "delete",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};
